// 大气监测
<template>
  <div class="main-middle" v-if="isRefresh">
    <div class="eqmtabs">
      <div class="tabsL">
        <el-tabs v-model="average" style="margin-left: 10px, margin-bottom: 0" @tab-click="tabClick">
          <el-tab-pane label="   1小时平均  " name="hour"></el-tab-pane>
          <!-- <el-tab-pane label="   8小时平均  " name="hours8"></el-tab-pane> -->
          <el-tab-pane label="  24小时平均  " name="hours24"></el-tab-pane>
          <!-- <el-tab-pane label="    月平均    " name="monthly"></el-tab-pane> -->
          <!-- <el-tab-pane label="    季平均    " name="quarterly"></el-tab-pane> -->
          <el-tab-pane label="    年平均    " name="annual"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="tabsR">
        <el-tabs v-model="typeTab" style="margin-left: 10px, margin-bottom: 0">
          <el-tab-pane label="  表格  " name="table"></el-tab-pane>
          <el-tab-pane label="  图形  " name="chart"></el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div>
      <div v-show="typeTab == 'table'">
        <div style="text-align: left;">
          <!-- <el-button class="btn" type="primary" size="mini" @click="addRow">新增</el-button> -->
          <!-- <el-button class="btn" type="primary" size="mini" @click="deleteMany" style="width: 88px; height: 36px;">批量删除</el-button> -->
          <el-button class="btn" type="primary" size="mini" @click="handleRefresh" style="width: 88px; height: 36px;" icon="el-icon-refresh-right">刷新</el-button>
        </div>
        <div style="width: 100%">
          <table width="100%" border="1" class="mntTable" align="center">
            <tr>
              <th width="4%" class="cell thtitle">序号</th>
              <th width="12%" class="cell thtitle">时间</th>
              <th v-for="(clmItem, clmIndex) in eqmTtlList" :key="clmIndex" class="cell thtitle"
                >{{ clmItem.idName }} ({{ clmItem.unit }})</th>
              <th width="12%" class="cell thtitle">操作</th>
            </tr>
            <!-- <tr>
              <th class="cell thtitle" v-if="average==='hour'||average==='hours24'||average==='annual'">SO2</th>
              <th class="cell thtitle" v-if="average==='hour'||average==='hours24'||average==='annual'">NO2</th>
              <th class="cell thtitle" v-if="average==='hour'||average==='hours24'">CO (mg/)</th>
              <th class="cell thtitle" v-if="average==='hour'||average==='hours8'">O3</th>
              <th class="cell thtitle" v-if="average==='hours24'||average==='annual'">PM10</th>
              <th class="cell thtitle" v-if="average==='hours24'||average==='annual'">PM2.5</th>
              <th class="cell thtitle" v-if="average==='hours24'||average==='annual'">TSP</th>
              <th class="cell thtitle" v-if="average==='hour'||average==='hours24'||average==='annual'">NOx</th>
              <th class="cell thtitle" v-if="average==='quarterly'||average==='annual'">Pb</th>
              <th class="cell thtitle" v-if="average==='hours24'||average==='annual'">BaP</th>
            </tr> -->
            <tr v-for="(item, index) in eqmAtmosData" :key="index">
              <td class="cell tdcell" v-if="index < 2">0</td>
              <td class="cell tdcell" v-else>{{index-1+pageSize*(currentPage-1)}}</td>
              <td class="cell tdcell">
                <el-input v-if="item.editFlag" v-model="item.eqmTime" type="datetime-local"></el-input>
                <span v-else>{{item.eqmTime}}</span>
              </td>
              <td v-for="(clmItem, clmIndex) in eqmTtlList" :key="clmIndex" class="cell tdcell">
                <el-input v-if="item.editFlag" v-model="item.eqmList[clmIndex].value"></el-input>
                <span v-else>{{item.eqmList[clmIndex].value}}</span>
              </td>
              <!-- <td class="cell tdcell" v-if="average==='hour'||average==='hours24'||average==='annual'">
                <el-input v-if="item.editFlag" v-model="item.eqmaSO2"></el-input>
                <span v-else>{{item.eqmaSO2}}</span>
              </td>
              <td class="cell tdcell" v-if="average==='hour'||average==='hours24'||average==='annual'">
                <el-input v-if="item.editFlag" v-model="item.eqmaNO2"></el-input>
                <span v-else>{{item.eqmaNO2}}</span>
              </td>
              <td class="cell tdcell" v-if="average==='hour'||average==='hours24'">
                <el-input v-if="item.editFlag" v-model="item.eqmaCO"></el-input>
                <span v-else>{{item.eqmaCO}}</span>
              </td>
              <td class="cell tdcell" v-if="average==='hour'||average==='hours8'">
                <el-input v-if="item.editFlag" v-model="item.eqmaO3"></el-input>
                <span v-else>{{item.eqmaO3}}</span>
              </td>
              <td class="cell tdcell" v-if="average==='hours24'||average==='annual'">
                <el-input v-if="item.editFlag" v-model="item.eqmaPM10"></el-input>
                <span v-else>{{item.eqmaPM10}}</span>
              </td>
              <td class="cell tdcell" v-if="average==='hours24'||average==='annual'">
                <el-input v-if="item.editFlag" v-model="item.eqmaPM2o5"></el-input>
                <span v-else>{{item.eqmaPM2o5}}</span>
              </td>
              <td class="cell tdcell" v-if="average==='hours24'||average==='annual'">
                <el-input v-if="item.editFlag" v-model="item.eqmaTSP"></el-input>
                <span v-else>{{item.eqmaTSP}}</span>
              </td>
              <td class="cell tdcell" v-if="average==='hour'||average==='hours24'||average==='annual'">
                <el-input v-if="item.editFlag" v-model="item.eqmaNOx"></el-input>
                <span v-else>{{item.eqmaNOx}}</span>
              </td>
              <td class="cell tdcell" v-if="average==='quarterly'||average==='annual'">
                <el-input v-if="item.editFlag" v-model="item.eqmaPb"></el-input>
                <span v-else>{{item.eqmaPb}}</span>
              </td>
              <td class="cell tdcell" v-if="average==='hours24'||average==='annual'">
                <el-input v-if="item.editFlag" v-model="item.eqmaBaP"></el-input>
                <span v-else>{{item.eqmaBaP}}</span>
              </td> -->
              <td class="cell tdcell" v-if="index < 2">
                <el-button type="text" size="mini" @click="editRow(item)" v-if="!item.editFlag">编辑</el-button>
                <!-- <el-button type="text" size="mini" @click="saveRow(item)">保存</el-button> -->
                <el-button type="text" size="mini" @click="saveDftRow(item)" v-else> 保存</el-button>
                <!-- <el-button type="text" size="mini" @click="deleteRow(item)">删除</el-button> -->
              </td>
              <td class="cell tdcell" v-else>
              </td>
            </tr>
          </table>
        </div>
        <div class="bottom-pagination">
          <el-pagination
            hide-on-single-page
            small
            background
            layout="prev, pager, next, jumper"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="currentPage"
            :total="totalNumber">
          </el-pagination>
        </div>
      </div>
      <div class="highcharts-container1" v-show="typeTab == 'chart'" style="width: 100%">
        <div style="width: 100%; height: 500px; flex: none;">
          <highcharts id="highcharts" :options="showChart1"></highcharts>
        </div>
        <!-- <div style="width: 50%; height: 500px; flex: none;">
          <highcharts :options="showChart2"></highcharts>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// import { charts } from 'highcharts'
import api from '../../../api/index'
export default {
  props: ['markerOrder'],
  data () {
    return {
      average: 'hour',
      typeTab: 'table',
      isRefresh: true,
      eqmTotalData: [],
      // eqmAtmosData: [{
      //   order: 0,
      //   eqmTime: null,
      //   eqmaSO2: null,
      //   eqmaNO2: null,
      //   eqmaCO: null,
      //   eqmaO3: null,
      //   eqmaPM10: null,
      //   eqmaPM2o5: null,
      //   eqmaTSP: null,
      //   eqmaNOx: null,
      //   eqmaPb: null,
      //   eqmaBaP: null,
      //   editFlag: false
      // }],
      //   order: 1,
      //   eqmTime: '2021.9.22',
      //   eqmaSO2: 500,
      //   eqmaNO2: 200,
      //   eqmaCO: 10,
      //   eqmaO3: 200,
      //   eqmaPM10: null,
      //   eqmaPM2o5: null,
      //   eqmaTSP: null,
      //   eqmaNOx: 250,
      //   eqmaPb: null,
      //   eqmaBaP: null,
      //   editFlag: false
      // }, {
      //   order: 2,
      //   eqmTime: '2021.9.23',
      //   eqmaSO2: 450,
      //   eqmaNO2: 150,
      //   eqmaCO: 9,
      //   eqmaO3: 160,
      //   eqmaPM10: null,
      //   eqmaPM2o5: null,
      //   eqmaTSP: null,
      //   eqmaNOx: 200,
      //   eqmaPb: null,
      //   eqmaBaP: null,
      //   editFlag: false
      // }, {
      //   order: 3,
      //   eqmTime: '2021.9.24',
      //   eqmaSO2: 500,
      //   eqmaNO2: 150,
      //   eqmaCO: 8,
      //   eqmaO3: 180,
      //   eqmaPM10: null,
      //   eqmaPM2o5: null,
      //   eqmaTSP: null,
      //   eqmaNOx: 100,
      //   eqmaPb: null,
      //   eqmaBaP: null,
      //   editFlag: false
      // }, {
      //   order: 4,
      //   eqmTime: '2021.9.25',
      //   eqmaSO2: 500,
      //   eqmaNO2: 150,
      //   eqmaCO: 8,
      //   eqmaO3: 180,
      //   eqmaPM10: null,
      //   eqmaPM2o5: null,
      //   eqmaTSP: null,
      //   eqmaNOx: 100,
      //   eqmaPb: null,
      //   eqmaBaP: null,
      //   editFlag: false
      // }],
      eqmTtlList: [{
        id: 0,
        idName: '0',
        unit: '0',
        value: 0,
        ratio: 0,
        mT3: 0,
        mT4: 0
      }, {
        id: 1,
        idName: '1',
        unit: '1',
        value: 1,
        ratio: 1,
        mT3: 1,
        mT4: 1
      }],
      eqmAtmosData: [{
        order: 0,
        eqmTime: '超标值',
        eqmList: [{
          id: 0,
          idName: '0',
          unit: '0',
          value: 0
          // 'ratio: 0
        }, {
          id: 1,
          idName: '1',
          unit: '1',
          value: 1
          // 'ratio: 1
        }]
      }, {
        order: 0,
        eqmTime: '预警值',
        eqmList: [{
          id: 0,
          idName: '0',
          unit: '0',
          value: 0
          // 'ratio: 0
        }, {
          id: 1,
          idName: '1',
          unit: '1',
          value: 1
          // 'ratio: 1
        }]
      }, {
        order: 1,
        eqmTime: null,
        eqmList: [{
          id: 0,
          idName: '0',
          // unit: '0',
          value: 0
          // ratio: 0,
          // mT3: 0,
          // mT4: 0
        }, {
          id: 1,
          idName: '1',
          // unit: '1',
          value: 1
          // ratio: 1,
          // mT3: 1,
          // mT4: 1
        }],
        editFlag: false
      }, {
        order: 2,
        eqmTime: null,
        eqmList: [{
          id: 0,
          idName: '0',
          // unit: '0',
          value: 0
          // ratio: 0,
          // mT3: 0,
          // mT4: 0
        }, {
          id: 1,
          idName: '1',
          // unit: '1',
          value: 1
          // ratio: 1,
          // mT3: 1,
          // mT4: 1
        }],
        editFlag: false
      }],
      eqmOtherData: [],
      pageSize: 10,
      currentPage: 1,
      totalNumber: 10,
      rowItems: {
        hour: ['eqmaSO2', 'eqmaNO2', 'eqmaCO', 'eqmaO3', 'eqmaNOx'],
        hours8: ['eqmaO3'],
        hours24: ['eqmaSO2', 'eqmaNO2', 'eqmaCO', 'eqmaPM10', 'eqmaPM2o5', 'eqmaTSP', 'eqmaNOx', 'eqmaBaP'],
        quarterly: ['eqmaPb'],
        annual: ['eqmaSO2', 'eqmaNO2', 'eqmaPM10', 'eqmaPM2o5', 'eqmaTSP', 'eqmaNOx', 'eqmaPb', 'eqmaBaP']
      },
      atmosItems: {
        hour: ['oneSO2', 'oneNO2', 'oneCO', 'oneO3', 'oneNOx'],
        hours8: ['eightO3'],
        hours24: ['daySO2', 'dayNO2', 'dayCO', 'dayPM10', 'dayPM2o5', 'dayTSP', 'dayNOx', 'dayBaP'],
        quarterly: ['quarterlyPb'],
        annual: ['annualSO2', 'annualNO2', 'annualPM10', 'annualPM2o5', 'annualTSP', 'annualNOx', 'annualPb', 'annualBaP']
      }
      // basicItemNum: 4,
      // otherItemNum: 1
    }
  },
  mounted () {
    this.getEQMAtmos()
    // this.tabClick()
  },
  computed: {
    showChart1: function () {
      this.chartInit()
      return this.chartOptions1
    }
    // showChart2: function () {
    //   this.chartInit()
    //   return this.chartOptions1
    // }
  },
  methods: {
    tabClick () {
      // switch (this.average) {
      //   case 'hour':
      //     this.basicItemNum = 4
      //     this.otherItemNum = 1
      //     break
      //   case 'hours8':
      //     this.basicItemNum = 1
      //     this.otherItemNum = 0
      //     break
      //   case 'hours24':
      //     this.basicItemNum = 5
      //     this.otherItemNum = 3
      //     break
      //   case 'quarterly':
      //     this.basicItemNum = 0
      //     this.otherItemNum = 1
      //     break
      //   case 'annual':
      //     this.basicItemNum = 4
      //     this.otherItemNum = 4
      //     break
      // }
      this.$nextTick(() => {
        this.getEQMAtmos()
      })
    },
    getEQMAtmos (pageNo = 1) {
      console.log(this.markerOrder)
      var averageC = 0
      switch (this.average) {
        case 'hour':
          averageC = 1
          break
        case 'hours24':
          averageC = 2
          break
        case 'annual':
          averageC = 3
          break
      }
      api.hbOnlineAddEnquiry({
        pages: this.pageSize,
        pageNo: pageNo,
        onlineMonitoringId: this.markerOrder,
        category: averageC
      }).then(res => {
        console.log('res', res)
        this.totalNumber = res.data.totalNumber
        var tempList = res.data.list
        var tempTL = res.data.totalList
        var topT3Row = []
        var topT4Row = []
        tempTL.forEach(clmItem => {
          var elemT3 = {
            id: clmItem.id,
            idName: clmItem.idName,
            value: clmItem.mT3,
            editFlag: false
          }
          topT3Row.push(elemT3)
          var elemT4 = {
            id: clmItem.id,
            idName: clmItem.idName,
            value: clmItem.mT4,
            editFlag: false
          }
          topT4Row.push(elemT4)
        })
        var top2Rows = [{
          order: 0,
          eqmTime: '超标值',
          eqmList: topT4Row,
          editFlag: false
        }, {
          order: 0,
          eqmTime: '预警值',
          eqmList: topT3Row,
          editFlag: false
        }]
        var otherRows = []
        tempList.forEach((rowItem, rowIndex) => {
          var newRow = {
            order: rowIndex + 1,
            eqmTime: rowItem.eqmTime,
            eqmList: [],
            editFlag: false
          }
          tempTL.forEach(clmItem => {
            var newRowItem = rowItem.eqmList.filter(cellItem => {
              return cellItem.idName === clmItem.idName
            })
            console.log('newRowItem', newRowItem)
            if (newRowItem.length) {
              newRow.eqmList.push(newRowItem[0])
            } else {
              newRow.eqmList.push({
                id: 0,
                idName: '',
                unit: '',
                value: '/'
              })
            }
          })
          otherRows.push(newRow)
        })
        this.eqmTtlList = tempTL
        this.eqmOtherData = otherRows
        this.eqmAtmosData = [...top2Rows, ...otherRows]
        console.log('this.eqmTtlList', this.eqmTtlList)
        console.log('this.eqmAtmosData', this.eqmAtmosData)
        this.chartInit()
      })
    },
    addRow () {
      var addPusher = {}
      addPusher.onlineId = this.markerOrder
      addPusher.time = ''
      for (var i = 0; i < this.atmosItems[this.average].length; i++) {
        addPusher[this.atmosItems[this.average][i]] = ''
      }
      api.hbOnlineAdd(addPusher).then(res => {
        console.log(res)
        this.$nextTick(function () {
          this.getEQMAtmos(this.currentPage)
        })
      })
      // this.eqmAtmosData.push({
      //   order: this.eqmAtmosData.length > 0 ? this.eqmAtmosData[this.eqmAtmosData.length - 1].order + 1 : 1,
      //   eqmTime: '',
      //   eqmaSO2: '',
      //   eqmaNO2: '',
      //   eqmaCO: '',
      //   eqmaO3: '',
      //   eqmaPM10: '',
      //   eqmaPM2o5: '',
      //   eqmaTSP: '',
      //   eqmaNOx: '',
      //   eqmaPb: '',
      //   eqmaBaP: '',
      //   editFlag: false
      // })
      // var addPusher = {}
      // addPusher.onlineId = this.markerOrder
      // addPusher.time = '00:00'
      // addPusher.oneSO2 = ''
      // addPusher.oneNO2 = ''
      // addPusher.oneCO = ''
      // addPusher.oneO3 = ''
      // addPusher.oneNOx = ''
      // addPusher.eightO3 = ''
      // addPusher.daySO2 = ''
      // addPusher.dayNO2 = ''
      // addPusher.dayCO = ''
      // addPusher.dayPM10 = ''
      // addPusher.dayPM2o5 = ''
      // addPusher.dayTSP = ''
      // addPusher.dayNOx = ''
      // addPusher.dayBaP = ''
      // addPusher.quarterlyPb = ''
      // addPusher.annualSO2 = ''
      // addPusher.annualNO2 = ''
      // addPusher.annualPM10 = ''
      // addPusher.annualPM2o5 = ''
      // addPusher.annualTSP = ''
      // addPusher.annualNOx = ''
      // addPusher.annualPb = ''
      // addPusher.annualBaP = ''
      // api.hbOnlineAdd(addPusher).then(res => {
      //   console.log(res)
      //   this.$nextTick(function () {
      //     this.getEQMAtmos(this.currentPage)
      //   })
      // })
    },
    editRow (row) {
      console.log('editRow')
      row.editFlag = true
    },
    saveDftRow (row) {
      console.log('saveDftRow')
      row.editFlag = false
      var pList = ''
      row.eqmList.forEach(eqmLI => {
        var tempI = `${eqmLI.idName},${eqmLI.value};`
        pList += tempI
      })
      var pusher = {
        onlineMonitoringId: this.markerOrder,
        type: row.eqmTime === '预警值' ? 'mT3' : 'mT4',
        pusherOne: pList
      }
      console.log(pusher)
      api.hbOnlineAddUpdate(pusher).then(res => {
        console.log('saveDftRow', res)
        this.$nextTick(() => {
          this.getEQMAtmos(this.currentPage)
        })
      })
    },
    saveRow (row) {
      console.log('saveRow')
      row.editFlag = false
      var savePusher = {}
      savePusher.id = row.order
      if (row.eqmTime) { savePusher.time = row.eqmTime } else { savePusher.time = '' }
      for (var i = 0; i < this.atmosItems[this.average].length; i++) {
        if (row[this.rowItems[this.average][i]]) { savePusher[this.atmosItems[this.average][i]] = row[this.rowItems[this.average][i]] } else { savePusher[this.atmosItems[this.average][i]] = '' }
      }
      console.log(savePusher)
      api.hbOnlineUpdate(savePusher).then(res => {
        console.log(res)
        this.$nextTick(function () {
          this.getEQMAtmos(this.currentPage)
        })
      })
      // if (this.average === 'hour') {
      //   savePusher = {
      //     id: row.order,
      //     time: row.eqmTime,
      //     oneSO2: row.eqmaSO2,
      //     oneNO2: row.eqmaNO2,
      //     oneCO: row.eqmaCO,
      //     oneO3: row.eqmaO3,
      //     oneNOx: row.eqmaNOx
      //   }
      // } else if (this.average === 'hours8') {
      //   savePusher = {
      //     id: row.order,
      //     time: row.eqmTime,
      //     eightO3: row.eqmaO3
      //   }
      // } else if (this.average === 'hours24') {
      //   savePusher = {
      //     id: row.order,
      //     time: row.eqmTime,
      //     daySO2: row.eqmaSO2,
      //     dayNO2: row.eqmaNO2,
      //     dayCO: row.eqmaCO,
      //     dayPM10: row.eqmaPM10,
      //     dayPM2o5: row.eqmaPM2o5,
      //     dayTSP: row.eqmaTSP,
      //     dayNOx: row.eqmaNOx,
      //     dayBaP: row.eqmaBaP
      //   }
      // } else if (this.average === 'quarterly') {
      //   savePusher = {
      //     id: row.order,
      //     time: row.eqmTime,
      //     quarterlyPb: row.eqmaPb
      //   }
      // } else if (this.average === 'annual') {
      //   savePusher = {
      //     id: row.order,
      //     time: row.eqmTime,
      //     annualSO2: row.eqmaSO2,
      //     annualNO2: row.eqmaNO2,
      //     annualPM10: row.eqmaPM10,
      //     annualPM2o5: row.eqmaPM2o5,
      //     annualTSP: row.eqmaTSP,
      //     annualNOx: row.eqmaNOx,
      //     annualPb: row.eqmaPb,
      //     annualBaP: row.eqmaBaP
      //   }
      // }
      // console.log(savePusher)
      // api.hbOnlineUpdate(savePusher).then(res => {
      //   console.log(res)
      //   this.$nextTick(function () {
      //     this.getEQMAtmos(this.currentPage)
      //   })
      // })
    },
    deleteRow (event) {
      this.deleteArr = event
      console.log(this.deleteArr)
      api.hbOnlineDelete({
        id: event.order
      }).then(res => {
        console.log(res)
        this.getEQMAtmos()
      })
    },
    // deleteMany () {
    //   this.deleteData()
    // },
    // deleteData () {
    //   var strData = ''
    //   this.deleteArr.forEach(element => {
    //     strData = strData + element.order + ','
    //   })
    //   this.deleteCheckData(strData)
    //   console.log(strData)
    // },
    // deleteCheckData (strId) {
    //   api.eiaBusinessDelete({
    //     id: strId
    //   }).then(res => {
    //     console.log(res)
    //     this.getCustomerment(this.currentPage)
    //   })
    // },
    handleRefresh () {
      this.isRefresh = false
      this.$nextTick(function () {
        this.isRefresh = true
        this.getEQMAtmos()
      })
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getEQMAtmos(this.currentPage)
    },
    table_index (index) {
      return index < 2 ? 0 : (this.currentPage - 1) * this.pageSize + index + 1 - 2
    },
    chartInit () {
      var chartDates = []
      this.eqmOtherData.forEach(rowItem => {
        chartDates.push(rowItem.eqmTime)
      })
      console.log('chartDates', chartDates)
      var chartData = []
      this.eqmTtlList.forEach(clmItem => {
        var rowData = {
          name: `${clmItem.idName} (${clmItem.unit})`,
          data: []
        }
        this.eqmOtherData.forEach(rowItem => {
          var rowDataItem = rowItem.eqmList.filter(cellItem => {
            return cellItem.idName === clmItem.idName
          })
          if (rowDataItem.length) {
            rowData.data.push(Number(rowDataItem[0].value))
          } else {
            rowData.data.push(null)
          }
        })
        chartData.push(rowData)
      })
      console.log('chartData', chartData)
      // var chartSeriesDatas = {
      //   xDates: { name: '时间', data: [] },
      //   xSO2: { name: 'SO2', data: [] },
      //   xNO2: { name: 'NO2', data: [] },
      //   xCO: { name: 'CO(mg/)', data: [] },
      //   xO3: { name: 'O3', data: [] },
      //   xPM10: { name: 'PM10', data: [] },
      //   xPM2o5: { name: 'PM2.5', data: [] },
      //   xTSP: { name: 'TSP', data: [] },
      //   xNOx: { name: 'NOx', data: [] },
      //   xPb: { name: 'Pb', data: [] },
      //   xBaP: { name: 'BaP', data: [] }
      // }
      // this.eqmAtmosData.forEach(element => {
      //   chartSeriesDatas.xDates.data.push(element.eqmTime)
      //   chartSeriesDatas.xSO2.data.push(element.eqmaSO2)
      //   chartSeriesDatas.xNO2.data.push(element.eqmaNO2)
      //   chartSeriesDatas.xCO.data.push(element.eqmaCO)
      //   chartSeriesDatas.xO3.data.push(element.eqmaO3)
      //   chartSeriesDatas.xPM10.data.push(element.eqmaPM10)
      //   chartSeriesDatas.xPM2o5.data.push(element.eqmaPM2o5)
      //   chartSeriesDatas.xTSP.data.push(element.eqmaTSP)
      //   chartSeriesDatas.xNOx.data.push(element.eqmaNOx)
      //   chartSeriesDatas.xPb.data.push(element.eqmaPb)
      //   chartSeriesDatas.xBaP.data.push(element.eqmaBaP)
      // })
      // console.log('chartSeriesDatas', chartSeriesDatas)
      // var chartSeries = []
      // if (this.average === 'hour') {
      //   chartSeries.push(
      //     chartSeriesDatas.xSO2,
      //     chartSeriesDatas.xNO2,
      //     chartSeriesDatas.xCO,
      //     chartSeriesDatas.xO3,
      //     chartSeriesDatas.xNOx
      //   )
      // } else if (this.average === 'hours8') {
      //   chartSeries.push(
      //     chartSeriesDatas.xO3
      //   )
      // } else if (this.average === 'hours24') {
      //   chartSeries.push(
      //     chartSeriesDatas.xSO2,
      //     chartSeriesDatas.xNO2,
      //     chartSeriesDatas.xCO,
      //     chartSeriesDatas.xPM10,
      //     chartSeriesDatas.xPM2o5,
      //     chartSeriesDatas.xTSP,
      //     chartSeriesDatas.xNOx,
      //     chartSeriesDatas.xBaP
      //   )
      // } else if (this.average === 'quarterly') {
      //   chartSeries.push(
      //     chartSeriesDatas.xPb
      //   )
      // } else if (this.average === 'annual') {
      //   chartSeries.push(
      //     chartSeriesDatas.xSO2,
      //     chartSeriesDatas.xNO2,
      //     chartSeriesDatas.xPM10,
      //     chartSeriesDatas.xPM2o5,
      //     chartSeriesDatas.xTSP,
      //     chartSeriesDatas.xNOx,
      //     chartSeriesDatas.xPb,
      //     chartSeriesDatas.xBaP
      //   )
      // }
      // console.log('chartSeries', chartSeries)
      this.chartOptions1 = {
        title: {
          text: '项目浓度'
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: chartDates
        },
        yAxis: {
          title: {
            text: '监测值'
          },
          allowDecimals: true
        },
        tooltip: {
          enabled: true,
          valueDecimals: 1
        },
        legend: {
          layout: 'vertiacal',
          align: 'right',
          verticalAlign: 'bottom'
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false
            }
          }
        },
        series: chartData,
        responsive: {
          rules: [{
            condition: {
              maxWidth: 480
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                veticalAlign: 'bottom'
              }
            }
          }]
        }
      }
    }
  }
}
</script>

<style lang="scss">
.main-middle {
      flex: 1 1 50%;
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: auto;
      .eqmtabs{
        display: flex;
        .tabsL{
          flex: 7;
        }
        .tabsR{
          flex: 1;
          text-align: right;
        }
      }
      .mntDetailTable {
        flex: 1;
        position: relative;
        overflow-y: scroll;
        border-radius: 4px;
        width: calc(95% - 10px);
        /deep/ .el-table__fixed-right {
          height: 100% !important; //设置高优先，以覆盖内联样式
        }
        /deep/ .el-table--scrollable-x .el-table__body-wrapper {
          overflow: auto !important;
        }
        /deep/.el-table__fixed-right-patch {
          background-color: #f5f7fa !important;
        }
        // /deep/ .el-table__fixed {
        //   height: 100% !important; //设置高优先，以覆盖内联样式
        // }
        .el-input__inner{
          height: 24px;
        }
        .el-icon-time{
          margin-top: -2px!important;
        }
      }
      .mntTable{
        .cell{
          border: 1px #ccc solid;
        }
        .thtitle{
          background-color: #fafafa;
          line-height: 24px;
        }
        .tdcell{
          background-color: #fff;
          line-height: 32px;
          padding: 2px;
          .el-input__inner{
            height: 28px!important;
          }
        }
      }
      .topsearchForm {
        padding-left: 20px;
        margin-bottom: 15px;
        margin-top: 5px;
        .el-form-item {
          margin-bottom: 0px
        }
      }
    }
    .btn-menu .el-button {
      margin-bottom: 10px!important;
      margin-left: 10px;
    }
    .bottom-pagination .el-pagination {
      text-align: right;
      margin-top: 6px;
      margin-bottom: 6px;
    }
    .el-dialog .dialog-form {
      width: 70%;
      margin: auto;
    }
    .btn{
      width: 88px;
      height: 36px;
      margin: 0 5px 5px 5px!important;
    }
    // .highcharts-root{
    //   height: 500px
    // }
    .highcharts-container {
      display: flex;
      width: 100%;
      height: 100%;
    }
    // #highcharts-11futo9-0{
    //   height: 500px;
    // }
    #highchart{
      height: 100%;
    }
</style>
